export default (errors: object) => {
    const messages = Object.values(errors);
    if (messages.length === 1) {
        return messages[0];
    }

    return messages.map((message, idx) => (
        <div key={idx} style={{ width: '100%' }}>{`• ${message.toString()}`}</div>
    ));
};
